import React, { useEffect, useState } from "react";
import { Accordion, Card } from "react-bootstrap";
import axios from 'axios';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import "./nikshay.css";
import { toast } from "react-toastify";
import { nikshayAPI } from "../../../services/nikshay.api";
import { transformToNikshayPayload } from '../utils/NikshayPayloadTransformer';
import SampleDetails, { createInitialSample } from './SampleDetails'; 
import FacilityDetails from './sections/FacilityDetails';
import TestResults from './sections/TestResults';
import TestDetails from './sections/TestDetails';
import Loader from "../../../components/Loader";
import nikshayValidationSchema from '../utils/nikshayValidationSchema';

const COMPLETE_INITIAL_VALUES = {
    // Basic Test Information
    ReasonForTesting: "",
    PredominantSymptom: "",
    PredominantSymptomDuration: "", // FIXED: removed colon
    TypeOfCase: "",
    HCPVisits: "",
    MonthsOfTreatment: "",
    MonthsSinceEpisode: "",
	FollowUpReasonDSTB: null,
    
    // Diagnosis Information
    DiagnosisOfTB: [],
    FollowUpReasonDSTB: "",
    TypeOfPresumptiveDRTB: [],
    CulturePositiveMonth: "",
    FollowUpReasonDRTB: "",
    FollowUpReasonDRTBMonth: "",
    
    // Test Details
    TestType: "",
    TestingFacilityState: { Value: "", Key: "", Level: null },
    TestingFacilityDistrict: { Value: "", Key: "", Level: null },
    TestingFacility: { Value: "", Key: "" },
    
    // Sample and Result Availability
    SampleAvailability: "Absent",
    ResultAvailability: "Absent",
    
    // Sample Details - CORRECTED structure with proper field names
    TestSampleDetails: [
        createInitialSample()
    ],

	//Facility and Site location
	TestingFacilityStateKey: "",
	TestingFacilityDistrictKey: "",
	TestingFacilityKey: "",
	collectionSiteStateKey: "",
	collectionSiteDistrictKey: "",
	
	// Lab Information
	LabSerialNumber: "",
	ResultSampleId: "",
	IndurationSize: "",
	ResultDateTested: "",
	ResultDateReported: "",
	ResultReportedBy: "",
	
	// FLLPA Fields
	FLLPA_AddMutationDetails: "Skip",
	FLLPASample: "",
	FLLPA_TUB_BAND: "",
	FLLPA_Rpob_Locus_Control: "",
	FLLPA_RpoB_WT1: "",
	FLLPA_RpoB_WT2: "",
	FLLPA_WT3: "",
	FLLPA_WT4: "",
	FLLPA_WT5: "",
	FLLPA_WT6: "",
	FLLPA_WT7: "",
	FLLPA_WT8: "",
	FLLPA_MUT1_D516V: "",
	FLLPA_MUT2A_H526Y: "",
	FLLPA_MUT2B_H526D: "",
	FLLPA_MUT3_S513L: "",
	FLLPA_KAT_G: "",
	FLLPA_KAT_WT1: "",
	FLLPA_KAT_MUT1: "",
	FLLPA_KAT_MUT2: "",
	FLLPA_INH_A: "",
	FLLPA_INH_WT1: "",
	FLLPA_INH_WT2: "",
	FLLPA_INH_MUT1: "",
	FLLPA_INH_MUT2: "",
	FLLPA_MUT3A: "",
	FLLPA_MUT3B: "",
	FLLPA_Result: "",
	
	// SLLPA Fields 
	SLLPA_AddMutationDetails: "Skip",
	SLLPA_Result: "",
	GYR_A_Locus_Control: "",
	SLLPA_WT1_85_90: "",
	SLLPA_WT2_89_93: "",
	SLLPA_WT3_92_97: "",
	SLLPA_MUT1_A90V: "",
	SLLPA_MUT2_S91P: "",
	SLLPA_MUT3A_D94A: "",
	SLLPA_MUT3B_D94N: "",
	SLLPA_MUT3C_D94G: "",
	SLLPA_MUT3D_D94H: "",
	GYR_B_Locus_Control: "",
	SLLPA_WT1_536_541: "",
	SLLPA_MUT1_N538D: "",
	SLLPA_MUT2_E540V: "",
	RRS_Locus_Control: "",
	SLLPA_WT1_1401_02: "",
	SLLPA_WT2_1484: "",
	SLLPA_MUT1_A1401G: "",
	SLLPA_MUT2_G148T: "",
	EIS_Locus_Control: "",
	SLLPA_WT1_37: "",
	SLLPA_WT2_14_12_10: "",
	SLLPA_WT3_2: "",
	SLLPA_MUT1_C_14T: "",

	//CY-tB 
	IndurationSize: null,
	
	// Other Test Results
	TextResult: "",
	CultureType: "",
	DSTToDrug: "",
	ResistanceStatus: "",
	PathodetectResult: "",
	
	// Resistance Results
	ResistanceToRifampicin: "",
	HighLevelResistanceToIsoniazid: "",
	LowLevelResistanceToIsoniazid: "",
	ResistanceToFluoroquinolones: "",
	ResistanceToSecondLineInjectableDrugs: "",
	ResistanceToSecondLineInjectableDrugsLowLevel: "",
	
	// Final Results
	FinalInterpretation: "",
	Remarks: "",
	PatientId: ""
};


const TESTS_WITHOUT_SAMPLE_AVAILABILITY = [
	"Chest X Ray",
	"Cytopathology",
	"Histopathology",
	"Gene Sequencing",
	"TST",
	"IGRA",
	"Cy-Tb",
	"Other",
];

export default function NikshayTest({ 
	onClose, 
	onTestAdded, 
	patientId: patientIdProp, 
	nikshayProfileData, 
	setShowNikshayActions, 
	setNikshayInitialTab 
}) {

	const [loader, setLoader] = useState(false);
	const [initialValues, setInitialValues] = useState(null);
	const [isReady, setIsReady] = useState(false);
	const [userHierarchy, setUserHierarchy] = useState(null);
	const [tuName, setTuName] = useState("");
	const [nikshayUserId, setNikshayUserId] = useState(null);

	// Resolve patient profile from props or local storage
	const profile = nikshayProfileData 
		|| JSON.parse(localStorage.getItem("NIKSHAY_Registration_Detials") || "{}");

	const patientID = patientIdProp 
		|| profile?.PatientId 
		|| profile?.Id 
		|| "";

	const patientName = profile?.FirstName && profile?.LastName 
		? `${profile?.FirstName} ${profile?.LastName}` 
		: (profile?.name || profile?.FirstName || profile?.LastName || "N/A");

	const patientAge = profile?.Age || "N/A";

	useEffect(() => {
		const fetchUserDetails = async () => {
			let mergedValues = { ...COMPLETE_INITIAL_VALUES };
			try {
				const storedUser = JSON.parse(
					localStorage.getItem("NIKSHAY_loggedinUserdetails")
				);

				if (storedUser?.id) {
					setNikshayUserId(storedUser.id);
				}

				let hierarchyId = null;
				let resolvedLevel = null;
				let resolvedUserId = null;

				// Get username for the auto-login mapping API call
				const username = storedUser?.username || localStorage.getItem("user_map_id");

				if (username) {
					try {
						const mappingResponse = await axios.get(
							`/nodeapi/program-mapping/auto-login/${username}`
						);
						if (mappingResponse.data?.success && mappingResponse.data?.data) {
							const programMappings = mappingResponse.data.data;
							const nikshayMapping = programMappings.find(
								(mapping) => mapping.ProgramMapping?.program_name === "Nikshay"
							);
							if (nikshayMapping?.programDetails?.response_login_api) {
								const loginResponse = typeof nikshayMapping.programDetails.response_login_api === "string"
									? JSON.parse(nikshayMapping.programDetails.response_login_api)
									: nikshayMapping.programDetails.response_login_api;

								resolvedLevel = loginResponse?.data?.hierarchy?.[0]?.hierarchy?.level;
								resolvedUserId = loginResponse?.data?.user?.id;
								if (resolvedUserId) {
									setNikshayUserId(resolvedUserId);
								}

								// Also extract hierarchyId from the response if not already present in storedUser
								if (loginResponse?.data?.user?.hierarchyId) {
									hierarchyId = loginResponse.data.user.hierarchyId;
								}
							}
						}
					} catch (e) {
						console.error("Error fetching program mapping auto-login details:", e);
					}
				}

				// Fallbacks for hierarchyId if the auto-login API didn't resolve it or failed
				if (!hierarchyId) {
					if (storedUser?.hierarchyId) {
						hierarchyId = storedUser.hierarchyId;
					} else if (storedUser?.response_login_api) {
						const parsedResponse = typeof storedUser.response_login_api === "string"
							? JSON.parse(storedUser.response_login_api)
							: storedUser.response_login_api;
						hierarchyId = parsedResponse?.data?.user?.hierarchyId;
					}
				}

				if (hierarchyId) {
					const data = await nikshayAPI.getUserDetailsWithHierarchy(hierarchyId);
					console.log("Response from getUserDetailsWithHierarchy API:", data);
					if (data) {
						if (data.level4Name) {
							setTuName(data.level4Name);
						}
						const stateValue = data.level2Name || "";
						const stateKey = data.level2Id ? String(data.level2Id) : "";
						const districtValue = data.level3Name || "";
						const districtKey = data.level3Id ? String(data.level3Id) : "";

						const hierarchyDefaults = {
							collectionSiteState: stateValue,
							collectionSiteStateKey: stateKey,
							collectionSiteStateLevel: resolvedLevel,
							collectionSiteDistrict: districtValue,
							collectionSiteDistrictKey: districtKey,
							collectionSiteDistrictLevel: resolvedLevel,
							referralSiteState: "",
							referralSiteStateKey: "",
							referralSiteStateLevel: null,
							referralSiteDistrict: "",
							referralSiteDistrictKey: "",
							referralSiteDistrictLevel: null,
						};

						setUserHierarchy({
							...hierarchyDefaults,
							// Keep the original user state/district to use as enabled constraints in the dropdowns
							allowedState: stateValue,
							allowedDistrict: districtValue,
						});

						// Pre-populate each sample's collection/referral site state & district
						const prefillledSamples = (mergedValues.TestSampleDetails || [createInitialSample()]).map(
							(sample) => ({
								...sample,
								...hierarchyDefaults,
							})
						);

						mergedValues = {
							...mergedValues,
							TestingFacilityState: {
								Value: stateValue,
								Key: stateKey,
								Level: resolvedLevel
							},
							TestingFacilityDistrict: {
								Value: districtValue,
								Key: districtKey,
								Level: resolvedLevel
							},
							TestSampleDetails: prefillledSamples,
						};
					}
				} else {
					console.warn("Hierarchy ID not found in localStorage.");
				}
			} catch (error) {
				console.error("Error fetching user details with hierarchy:", error);
			} finally {
				// Always set the initial values and mark the form as ready,
				// even if the API call fails. This ensures the form renders
				// with stable initialValues so Formik never reinitializes.
				setInitialValues(mergedValues);
				setIsReady(true);
			}
		};

		fetchUserDetails();
	}, []);
	return (
		<div className="nikshay-test-container">
			{loader && <Loader />}

			<div className="d-flex align-items-center mb-3">
			</div>

			{/* --------------------- Accordion Wrapper --------------------- */}
			<Accordion defaultActiveKey="0" alwaysOpen className="nikshay-customaccordian">

				{/* --------------------- Test Details --------------------- */}
				<Accordion.Item eventKey="0" className="nk-card">
					<Accordion.Header>
					{setShowNikshayActions && (
						<button 
							type="button" 
							className="btn btn-sm d-flex align-items-center gap-1 me-2"
							style={{ 
								backgroundColor: "#f0f2f5", 
								fontWeight: "600",
							}}
							onClick={(e) => {
								e.stopPropagation(); // Prevent accordion header from toggling
								if (setNikshayInitialTab) {
									setNikshayInitialTab("details");
								}
								setShowNikshayActions("View Nikshay Details");
							}}
						>
							<span style={{ fontSize: "16px", lineHeight: "1" }}>←</span> Back
						</button>
					)}
					<img
					src="/images/nikshayicon.svg"
					alt="Nikshay"
					style={{ width: "50px" }}
					className="me-2"
					/>
					<h4 className="mb-0 fw-bold">Add Test</h4>

						<div
							className="nikshayclose"
							onClick={() => onClose("handleCloseNikshayview")}
						>
							<div className="closeDive" onClick={() => onClose('handleCloseNikshaytest')}><img src="/images/closing.svg" alt="Close" /></div>
						</div>
					</Accordion.Header>

					<Accordion.Body>
						{/* Test Details Grid */}

						{!isReady ? (
							<div className="d-flex justify-content-center align-items-center p-4">
								<div className="spinner-border text-primary" role="status">
									<span className="visually-hidden">Loading...</span>
								</div>
							</div>
						) : (
						<>
						<Card className="mb-3">
							<Card.Body>
								<div className="row">
									<div className="col-md-3">
										<div className="form-group-nk">
											<label className="text-muted fw-bold d-block mb-1" style={{ fontSize: "13px" }}>Patient Name</label>
											<span className="fw-semibold text-dark" style={{ fontSize: "15px" }}>{patientName}</span>
										</div>
									</div>
									<div className="col-md-3">
										<div className="form-group-nk">
											<label className="text-muted fw-bold d-block mb-1" style={{ fontSize: "13px" }}>Patient ID</label>
											<span className="fw-semibold text-dark" style={{ fontSize: "15px" }}>{patientID}</span>
										</div>
									</div>
									<div className="col-md-3">
										<div className="form-group-nk">
											<label className="text-muted fw-bold d-block mb-1" style={{ fontSize: "13px" }}>Patient's Age</label>
											<span className="fw-semibold text-dark" style={{ fontSize: "15px" }}>{patientAge}</span>
										</div>
									</div>
									<div className="col-md-3">
										<div className="form-group-nk">
											<label className="text-muted fw-bold d-block mb-1" style={{ fontSize: "13px" }}>Location (TU)</label>
											<span className="fw-semibold text-dark" style={{ fontSize: "15px" }}>{tuName || "N/A"}</span>
										</div>
									</div>
								</div>
							</Card.Body>
						</Card>
						<Formik
							initialValues={initialValues}
							validationSchema={nikshayValidationSchema}
							onSubmit={async (values, { setSubmitting, resetForm }) => {
								try {
									setSubmitting(true);
									setLoader(true);

									const storedUser = JSON.parse(localStorage.getItem("NIKSHAY_loggedinUserdetails"));
									const finalUserId = nikshayUserId || storedUser?.id;

									// Transform form values to API payload
									const payload = transformToNikshayPayload(values, patientID, finalUserId);
									console.log("Submitting payload:", payload);

									// Step 1: Call addTest — response is { Success, Data: { RefId }, callBackRecord }
									const addTestRes = await nikshayAPI.addTest(payload);
									console.log("addTest response:", addTestRes);
									// Step 2: Check if callBackRecord came with addTest response
									let callBackRecord = addTestRes?.callBackRecord;

									if (!callBackRecord) {
										throw new Error("Test has not been added. Please try again.");
									}


									// Step 3: Determine success from callBackRecord.json_received.Success
									const isSuccess = callBackRecord?.json_received?.Success;
									const errorMessage = callBackRecord?.json_received?.Data?.Response;

									if (!isSuccess) {
										let friendlyError = errorMessage || "Nikshay processing failed.";
										try {
											if (errorMessage) {
												const parsed = JSON.parse(errorMessage);
												friendlyError = parsed?.error || friendlyError;
											}
										} catch (e) {
											// Keep raw errorMessage as fallback
										}
										throw new Error(friendlyError);
									}

									// Show success message and reset the form to a fresh state
									toast.success("Test added successfully!");
									resetForm();

								} catch (error) {
									console.error("Submission failed:", error);
									toast.error("Failed to submit test: " + error.message);
								} finally {
									setSubmitting(false);
									setLoader(false);
								}
							}}
						>


							{({ values, handleChange, setFieldValue, handleSubmit, errors, touched, isSubmitting, submitCount}) =>{
								// console.log("Values:", values);
							return(
								<>
								<TestDetails 
									values={values}
									handleChange={handleChange}
									setFieldValue={setFieldValue}
									testsWithoutSampleAvailability={TESTS_WITHOUT_SAMPLE_AVAILABILITY}
									errors={errors}      
        							touched={touched}
								/>

								{values.TestType !== "" && (
									<FacilityDetails 
										values={values}
										setFieldValue={setFieldValue}
										testType={values.TestType}
										errors={errors}      
          								touched={touched}  
									/>
									)}

									{values.SampleAvailability === 'Present' && (
									<SampleDetails
										values={values}
										setFieldValue={setFieldValue}
										userHierarchy={userHierarchy}
									/>
									)}

									{/* Test Results Component */}
									<TestResults
									values={values}
									setFieldValue={setFieldValue}
									testType={values.TestType}
									resultAvailability={values.ResultAvailability}
									/>

									{/* Footer buttons */}
									<div className="nk-footer align-items-center">
										{submitCount > 0 && Object.keys(errors).length > 0 && (
											<div className="text-danger fw-semibold text-start me-auto" style={{ fontSize: "14px" }}>
												Please fill all required fields correctly before submitting.
											</div>
										)}
										<button 
											type="submit" 
											className={`btn submit-btn ${isSubmitting ? 'disabled-btn' : ''}`}
											style={isSubmitting ? {
												backgroundColor: "#ffffff", 
												color: "#8a8a8a",           
												cursor: "not-allowed",     
												opacity: 0.6,              
												boxShadow: "none",      
												pointerEvents: "none",    
												border: "1px solid #ced4da"
											} : {}}
											onClick={handleSubmit}
											disabled={isSubmitting}
										>
											{isSubmitting ? "Submitting..." : "Submit Test"}
										</button>
									</div>
								</>
							)}}
						</Formik>
						</>
						)}
					</Accordion.Body>
				</Accordion.Item>
			</Accordion>
		</div>
	);
}

